import {
	ContentContainer,
	ContentBox,
	ContentTitle,
	ContentWrapper,
	ImageBox,
	ContentDesctiptionBonus
} from './ContentStyled';

import info_spin from '../assets/gameInterface/info_spin.png';
import info_auto from '../assets/gameInterface/info_auto.png';
import info_fast from '../assets/gameInterface/info_fast.png';
import info_fast_off from '../assets/gameInterface/info_fast_off.png';

import { GAME_INTERFACE_DESC } from '../helpers/content';

export default function GameInterface({
	dimentions,
	currentBet,
	currAbr,
	fast
}) {
	const GAME_INTERFACE = [
		{ img: fast ? info_fast : info_fast_off, text: 'Fast Play' },
		{ img: info_auto, text: 'Auto Play' },
		{ img: info_spin, text: 'Start Game' }
	];
	return (
		<ContentWrapper scale={dimentions.scale}>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>
						MAIN GAME INTERFACE
					</ContentTitle>
				</div>
			</ContentContainer>
			<ContentDesctiptionBonus scale={dimentions.scale}>
				{GAME_INTERFACE_DESC(currentBet, currAbr)}
			</ContentDesctiptionBonus>
			<ContentBox style={{ gap: '1vw' }}>
				{GAME_INTERFACE.map((item, id) => (
					<ImageBox key={id} className='game-interface'>
						<img src={item.img} alt='interface' />
						<p>{item.text}</p>
					</ImageBox>
				))}
			</ContentBox>
		</ContentWrapper>
	);
}
